import { render } from "./CartPopup.vue?vue&type=template&id=332db49a"
import script from "./CartPopup.vue?vue&type=script&lang=js"
export * from "./CartPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__